module.exports = __webpack_public_path__ + "img/1.b35c3f58.jpg";